/**
 * Roulette 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {ROULETTE_QUERY_KEY_MAP} from '../api/roulette/constant';
import {rouletteFactory} from '../factory/rouletteFactory';

// ============================================
// useRouletteInfoQuery
// ============================================

export function useRouletteInfoQuery(
  ...args: Parameters<typeof rouletteFactory.rouletteInfo>
) {
  return useQuery(rouletteFactory.rouletteInfo(...args));
}

useRouletteInfoQuery.getKey = (
  ...args: Parameters<typeof ROULETTE_QUERY_KEY_MAP.rouletteInfo>
) => [...ROULETTE_QUERY_KEY_MAP.rouletteInfo(...args)];
